import styled from '@emotion/styled'

export const TemporaryDataWrapper = styled.div`
  height: 540px;
  overflow-y: scroll;
`
